import { render, staticRenderFns } from "./BusinessForm.vue?vue&type=template&id=1d13ff30&scoped=true&"
import script from "./BusinessForm.vue?vue&type=script&lang=js&"
export * from "./BusinessForm.vue?vue&type=script&lang=js&"
import style0 from "./BusinessForm.vue?vue&type=style&index=0&id=1d13ff30&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d13ff30",
  null
  
)

export default component.exports